"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useImageSlider = useImageSlider;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Image = _interopRequireDefault(require("../Image"));
var _react = _interopRequireWildcard(require("react"));
var _ImageZoomableUi = _interopRequireDefault(require("../ImageZoomableUi"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _core = require("@commerce-ui/core2");
var _useSelectState2 = _interopRequireDefault(require("@commerce-ui/core2/useSelectState"));
var _ButtonArrow = require("../buttons/ButtonArrow");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useImageSlider(props) {
  var images = props.images,
    active = props.active,
    defaultActive = props.defaultActive,
    _onChange = props.onChange;
  var _useSelectState = (0, _useSelectState2["default"])({
      options: Array.from(Array(images.length).keys()),
      value: active,
      defaultValue: defaultActive,
      onChange: function onChange(newVal) {
        if (_onChange) {
          _onChange(newVal);
        }
      },
      allowEmpty: false
    }),
    value = _useSelectState.value,
    setValue = _useSelectState.setValue;
  return {
    active: value,
    setActive: setValue,
    activeImage: images[value],
    images: images
  };
}
var defaultProps = {
  sx: {}
};
var ImageSlider = function ImageSlider(props) {
  var isMobile = props.isMobile,
    arrowsForMobile = props.arrowsForMobile,
    photogridMobile = props.photogridMobile,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? defaultProps.sx : _props$sx,
    controller = props.controller;
  var _useState = (0, _react.useState)(false),
    arrowsVisible = _useState[0],
    setArrowVisible = _useState[1];
  var zoomState = (0, _react.useRef)({
    zoom: false,
    zoomCursor: false
  });
  var _useState2 = (0, _react.useState)({
      touchStartPosition: null,
      leftTouchDetected: null,
      isDragging: false
    }),
    touchState = _useState2[0],
    setTouchState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isMobile && arrowsForMobile && arrowsForMobile !== arrowsVisible) {
      setArrowVisible(true);
    }
  }, [isMobile]);
  var mobileImageRef = (0, _react.useRef)();
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  var image = (0, _core.getElementSpec)(customSx.$image, {
    __type: _Image["default"],
    $objectFit: "contain",
    width: "100%",
    height: "100%"
  }, {});
  var imageElem = (0, _core.createElement)(image, {
    image: controller.activeImage
  });
  var changeActiveImage = function changeActiveImage() {
    var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    controller.setActive(previous ? controller.active !== 0 ? controller.active - 1 : controller.images.length - 1 : controller.active + 1);
  };
  var handleTouchStart = (0, _react.useCallback)(function (imageTouch) {
    setTouchState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isDragging: true,
        touchStartPosition: imageTouch.touches[0].clientX
      });
    });
  }, []);
  var handleTouchMove = (0, _react.useCallback)(function (imageTouch) {
    var diffX = touchState.touchStartPosition - imageTouch.touches[0].clientX;
    if (diffX < 0) {
      setTouchState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          leftTouchDetected: true
        });
      });
      changeActiveImage(true);
    } else {
      setTouchState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          leftTouchDetected: false
        });
      });
      changeActiveImage();
    }
  }, [touchState.isDragging, touchState.touchStartPosition]);
  var handleTouchEnd = (0, _react.useCallback)(function () {
    if (touchState.isDragging) {
      setTouchState({
        touchStartPosition: null,
        leftTouchDetected: null,
        isDragging: false
      });
    }
  }, [touchState.isDragging, touchState.touchStartPosition]);
  var arrowButtonClick = function arrowButtonClick() {
    var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    controller.setActive(previous ? controller.active !== 0 ? controller.active - 1 : controller.images.length - 1 : controller.active + 1);
  };
  var changeArrowVisibility = function changeArrowVisibility() {
    var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    zoomState.current.zoom = zoom;
    zoomState.current.zoomCursor = false;
    if (arrowsVisible !== (zoom || out ? false : !arrowsVisible) && !isMobile) {
      setArrowVisible(!arrowsVisible);
    }
  };
  var arrowStyles = {
    position: "absolute",
    zIndex: 3,
    top: "50%"
  };
  var arrowIndent = arrowsForMobile ? [photogridMobile ? 15 : -15, 15, null, 15, -15] : [null, null, null, 15, -15];
  (0, _react.useEffect)(function () {
    var _mobileImageRef$curre, _mobileImageRef$curre2;
    mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre = mobileImageRef.current) === null || _mobileImageRef$curre === void 0 ? void 0 : _mobileImageRef$curre.addEventListener("touchmove", handleTouchMove);
    mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre2 = mobileImageRef.current) === null || _mobileImageRef$curre2 === void 0 ? void 0 : _mobileImageRef$curre2.addEventListener("touchend", handleTouchEnd);
    return function () {
      var _mobileImageRef$curre3, _mobileImageRef$curre4;
      mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre3 = mobileImageRef.current) === null || _mobileImageRef$curre3 === void 0 ? void 0 : _mobileImageRef$curre3.removeEventListener("touchmove", handleTouchMove);
      mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre4 = mobileImageRef.current) === null || _mobileImageRef$curre4 === void 0 ? void 0 : _mobileImageRef$curre4.removeEventListener("touchend", handleTouchEnd);
    };
  }, [handleTouchMove, handleTouchEnd]);
  var imageWithZoom = arrowsForMobile ? __jsx(_Box["default"], null, imageElem) : __jsx(_ImageZoomableUi["default"], {
    zoom: 2,
    cursorOverride: zoomState.current.zoomCursor
  }, __jsx(_Box["default"], {
    onClick: function onClick() {
      return changeArrowVisibility(!zoomState.current.zoom);
    },
    onMouseOver: function onMouseOver() {
      return changeArrowVisibility();
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility(false, true);
    }
  }, imageElem));
  var noZoomImage = __jsx(_Box["default"], null, imageElem);
  var mobileSlider = photogridMobile ? noZoomImage : __jsx(_Box["default"], {
    onTouchStart: handleTouchStart,
    ref: mobileImageRef
  }, imageElem);
  return __jsx(_Box["default"], null, arrowsVisible && controller.images.length > 1 && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, arrowStyles), {}, {
      left: arrowIndent
    })
  }, __jsx(_ButtonArrow.ButtonArrowBigLeft, {
    onClick: function onClick() {
      return arrowButtonClick(true);
    },
    onMouseEnter: function onMouseEnter() {
      zoomState.current.zoomCursor = true;
      setArrowVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility();
    }
  })), arrowsVisible && controller.images.length > 1 && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, arrowStyles), {}, {
      right: arrowIndent
    })
  }, __jsx(_ButtonArrow.ButtonArrowBigRight, {
    onClick: function onClick() {
      return arrowButtonClick();
    },
    onMouseEnter: function onMouseEnter() {
      zoomState.current.zoomCursor = true;
      setArrowVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility();
    }
  })), __jsx(_Box["default"], {
    sx: _objectSpread({
      cursor: "pointer"
    }, css)
  }, isMobile ? mobileSlider : photogridMobile ? noZoomImage : imageWithZoom));
};
var _default = ImageSlider;
exports["default"] = _default;